import React from 'react'
import './optionsHeader.scss'
import { useTranslation } from 'translations'

interface OptionsHeaderProps extends React.HTMLAttributes<HTMLElement> {
    filteredOptionsCount?: number
    totalOptionsCount?: number
    selectedCount?: number
    allFilteredOptionsSelected?: boolean
    onSelectAll?: () => void
    onDeselectAll?: () => void
}

const OptionsHeader = (props: OptionsHeaderProps) => {
    const { t } = useTranslation()
    const {
        filteredOptionsCount = 0,
        totalOptionsCount = 0,
        selectedCount = 0,
        allFilteredOptionsSelected = false,
        onSelectAll,
        onDeselectAll,
    } = props

    const handleButtonClick = () => {
        if (allFilteredOptionsSelected) {
            onDeselectAll?.()
        } else {
            onSelectAll?.()
        }
    }

    const allShown = filteredOptionsCount === totalOptionsCount
    const counts = { filtered: filteredOptionsCount, total: totalOptionsCount }
    let buttonText: string
    if (allFilteredOptionsSelected) {
        buttonText = allShown
            ? t('uiComponents.combobox.deselectAll', counts)
            : t('uiComponents.combobox.deselectFiltered', counts)
    } else {
        buttonText = allShown
            ? t('uiComponents.combobox.selectAll', counts)
            : t('uiComponents.combobox.selectFiltered', counts)
    }

    return filteredOptionsCount > 0 ? (
        <button className="combobox-options-header" onClick={handleButtonClick} type="button">
            <div className="combobox-selection-text">{buttonText}</div>
            {selectedCount > 0 && (
                <span className="combobox-selected-count">
                    {t('uiComponents.combobox.selectedCount', { selected: selectedCount })}
                </span>
            )}
        </button>
    ) : null
}

export default OptionsHeader
